import { theme_light } from "./common_light";

export const theme_uix_light = {
  ...theme_light,
  primary: {
    theme_lv1: "#437FB3", // テーマカラー1
    theme_lv2: "#9CCCF6", // テーマカラー2
    theme_lv3: "#DFF1FE", // テーマカラー3
    accent: "#F34824", // アクセントカラー（ボリュームゲージの最大、ボリューム閾値）
    bg_lv1: "#F4FBFF", // 背景色1
  },
};
